import React, { FC, memo, ChangeEvent } from 'react';
import { Select, MenuItem, FormControl, InputLabel } from '@material-ui/core';

interface Props {
  value: number;
  onChange: (value: number | undefined) => void;
}

const Component: FC<Props> = ({ value, onChange }) => {
  const handleChange = (event: ChangeEvent<{ value: any }>) => {
    const value = event?.target?.value;
    if (value === 2) {
      onChange(undefined);
    } else {
      onChange(value);
    }
  };

  return (
    <FormControl variant="outlined" fullWidth>
      <InputLabel id="cheque">Cheque</InputLabel>
      <Select
        labelId="cheque"
        value={value === undefined ? '' : value}
        onChange={handleChange}
        label="Cheque"
        defaultValue={undefined}
      >
        <MenuItem value={2}>All</MenuItem>
        <MenuItem value={1}>Visible in liability</MenuItem>
        <MenuItem value={0}>Not in liability</MenuItem>
      </Select>
    </FormControl>
  );
};

export const LiabilityFilters = memo(Component);
